/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Amount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'



/** @type {import('Simple/types.js').View} */
export default function Amount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/PayorShare/Amount"
  
}) {
let payorShareAmountValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'share.amount',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="payor.share.amount"
 value={payorShareAmountValueData}
 onChange={onChange}
 marginTop={0}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}